// Mirrors the backend enum on social_analytics_media.media_type.
export const MEDIA_TYPES = ['video', 'reel', 'short', 'image', 'carousel', 'unknown'] as const;
export type MediaType = (typeof MEDIA_TYPES)[number];

export const isMediaType = (value: unknown): value is MediaType => (
  typeof value === 'string' && (MEDIA_TYPES as readonly string[]).includes(value)
);

export const mediaTypeKey = (value: string | null | undefined): string => (
  `analytics.mediaTypes.${isMediaType(value) ? value : 'unknown'}`
);
